import CharsConverter from 'services/chars-converter/chars-converter';

export interface LineupPlayerToDownloadStructure {
    id: string;
    name: string;
    positionName: string;
}

export abstract class AbstractOptimizedLineupsView {
    constructor(private readonly charsConverter: CharsConverter) {}

    makeView(lineupsToDownload: LineupPlayerToDownloadStructure[][]): string[][] {
        if (isEmpty(lineupsToDownload)) {
            return [[]];
        }

        const csvHeader = lineupsToDownload[0].map((item) => item.positionName);

        const csvLineups = lineupsToDownload.map((lineupPlayers, index) => {
            return lineupPlayers.map((player) => this.getPlayerCellView(player));
        });

        return [csvHeader, ...csvLineups];
    }

    protected adjustPlayerName(playerName: string): string {
        return this.charsConverter.convertChars(playerName).replace(',', '');
    }

    protected abstract getPlayerCellView(player: LineupPlayerToDownloadStructure): string;
}
